import React from 'react';
import { Box, Close } from 'theme-ui';

import { myTheme } from '../theme';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export const Modal: React.FC<Props> = ({ children, isOpen, onClose }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <>
      <Box
        onClick={onClose}
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'black',
          zIndex: 99,
          opacity: 0.6,
        }}
      />
      <Box
        sx={{
          position: 'fixed',
          top: 'calc(50% - 25vh)',
          left: ['calc(50% - 40vw)', 'calc(50% - 30vw)', 'calc(50% - 20vw)'],
          width: ['80vw', '60vw', '40vw'],
          height: '50vh',
          backgroundColor: 'background',
          border: '1px solid',
          borderColor: 'primary',
          borderRadius: 10,
          zIndex: 100,
        }}>
        <Close
          onClick={onClose}
          sx={{
            position: 'absolute',
            top: 3,
            right: 3,
            color: 'primary',
            cursor: 'pointer',
            '&:hover': {
              opacity: 0.8,
            },
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            top: 5,
            left: 4,
            width: `calc(100% - ${myTheme.space[4] * 2}px)`,
            height: `calc(100% - ${myTheme.space[5] + myTheme.space[4]}px)`,
          }}>
          {children}
        </Box>
      </Box>
    </>
  );
};
